<div class="day-timeline">
  <div class="event-row">
    <div
      *ngFor="let event of dayEvents; trackBy: trackByEvent"
      class="event-dot"
      [matTooltip]="eventTooltip(event)"
      [style.left.%]="eventLeftPercent(event)"
      [style.width.px]="eventDotSize(event)"
      [style.height.px]="eventDotSize(event)"
    ></div>
  </div>

  <div
    #track
    class="track"
    [class.disabled]="disabled"
    [class.creation-unavailable]="!!creationLimitMessage"
    (pointerdown)="onTrackPointerDown($event)"
  >
    <div
      *ngFor="let h of hourGridIndices"
      class="gridline"
      [class.major]="isMajorGridline(h)"
      [style.left.%]="hourLineLeftPercent(h)"
    ></div>

    <div
      *ngFor="let seg of segments; trackBy: trackBySegmentId"
      data-segment
      class="segment"
      [matTooltip]="segmentLabel(seg)"
      [matTooltipDisabled]="!hasClippedSegmentLabel(seg)"
      [class.disabled]="disabled"
      [style.left.%]="segmentLeftPercent(seg)"
      [style.width.%]="segmentWidthPercent(seg)"
      (pointerdown)="onSegmentPointerDown($event, seg)"
    >
      <div
        class="handle handle-start"
        [class.disabled]="disabled"
        (pointerdown)="onResizeStartPointerDown($event, seg)"
      ></div>
      <div class="segment-label">
        {{ segmentLabel(seg) }}
      </div>
      <button
        *ngIf="!disabled"
        type="button"
        class="remove-button"
        aria-label="Remove segment"
        (pointerdown)="$event.stopPropagation()"
        (click)="removeSegment($event, seg.id)"
        >×</button
      >
      <div
        class="handle handle-end"
        [class.disabled]="disabled"
        (pointerdown)="onResizeEndPointerDown($event, seg)"
      ></div>
    </div>

    <div
      *ngIf="draftSeg"
      class="draft-segment"
      [style.left.%]="segmentLeftPercent(draftSeg)"
      [style.width.%]="segmentWidthPercent(draftSeg)"
    ></div>
  </div>

  <div class="hour-labels">
    <span *ngFor="let h of hourLabels" [style.left.%]="hourLineLeftPercent(h)"
      >{{ h.toString().padStart(2, '0') }}:00</span
    >
  </div>

  <p
    *ngIf="creationLimitMessage as message"
    class="creation-limit-message"
    role="status"
    >{{ message }}</p
  >
</div>
